var map = {
	"./2011-06_bloomberg.pdf": "7267",
	"./2011-09_bloomberg.pdf": "1f77",
	"./2012-02_bloomberg.pdf": "3382",
	"./2012-07_bloomberg.pdf": "a68c",
	"./2012-09_bloomberg.pdf": "5d39",
	"./2013-01_bloomberg.pdf": "bc0d",
	"./2013-06_bloomberg.pdf": "b57f",
	"./2013-12_bloomberg.pdf": "efa4",
	"./2014-01_bloomberg.pdf": "abcd",
	"./2014-01_bloomberg_b.pdf": "4359",
	"./2014-02_bloomberg.pdf": "e24f",
	"./2014-03_bloomberg.pdf": "ff20",
	"./2014-05_bloomberg.pdf": "9e66",
	"./2014-08_bloomberg.pdf": "9fda",
	"./2014-09_bloomberg.pdf": "49d3",
	"./2014-10_bloomberg.pdf": "7d4d",
	"./2014-11_bloomberg.pdf": "7c76",
	"./2014-11_bloomberg_a.pdf": "5d5d",
	"./2015-02_bloomberg.pdf": "149f",
	"./2015-02_bloomberg_a.pdf": "f29d",
	"./2015-04_bloomberg.pdf": "1a08",
	"./2015-05_bloomberg.pdf": "0071",
	"./2015-07_bloomberg.pdf": "ae65",
	"./2015-08_bloomberg.pdf": "eaaa",
	"./2015-12_bloomberg.pdf": "c91f",
	"./2016-07_bloomberg.pdf": "fa54",
	"./2017-03_bloomberg.pdf": "7c9c",
	"./2017-04_bloomberg.pdf": "2fc5",
	"./2017-09_bloomberg.pdf": "8ce9c",
	"./2019-04_bloomberg.pdf": "a92a",
	"./2019-06_bloomberg.pdf": "80aa",
	"./2019-09_bloomberg.pdf": "7ae7",
	"./2020-02_bloomberg.pdf": "d78b",
	"./2020-12_bloomberg.pdf": "a80c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c78d";